import H5 from '@base/H5/H5';
import Paper from '@base/Paper/Paper';
import HTMLWrapper from '@comp/Question/HTMLWrapper';
import { mediaQuery } from '@cont/Quiz/constants';
import useQuestion from '@cont/Quiz/Taking/Objective/Question/useQuestion';
import Dangerous from '@educator/Container/AutoDPP/DangerousContent';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { useEffect, useRef } from 'react';
import Question from './Question';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${Spacings.SPACING_4B};
  align-items: flex-start;
`;

const Comprehension = styled(Paper)`
  padding: ${Spacings.SPACING_6B};
  max-height: ${({ $MaxHeight }) => $MaxHeight || 'calc(100vh - 178px)'};
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    background-color: transparent;
    width: ${Spacings.SPACING_10};
  }
  ::-webkit-scrollbar-track {
    background-color: var(--color-i-white);
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--color-i-gray-20);
    border-radius: ${Spacings.SPACING_4B};
    border: 2px solid var(--color-i-white);
  }
  ::-webkit-scrollbar-track:hover {
    background-color: var(--color-i-gray-19);
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--color-i-gray-21);
    border: 2px solid var(--color-i-gray-19);
  }

  ${mediaQuery.aboveTablet} {
    padding: ${Spacings.SPACING_8B};
  }

  ${mediaQuery.aboveLargeScreen} {
    padding: ${Spacings.SPACING_10B};
  }
`;

const Title = styled(H5)`
  margin-bottom: ${Spacings.SPACING_4B};
  line-height: ${Spacings.SPACING_6B};
`;

const QuestionWithComprehension = ({ maxHeight }) => {
  const { questionUID, currentQuestion, currentLanguage } = useQuestion();
  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current.scrollTo(0, 0);
  }, [questionUID]);

  return (
    <Wrapper>
      <Comprehension $MaxHeight={maxHeight} ref={scrollRef}>
        <Title>Comprehension Passage</Title>
        <Dangerous
          as={HTMLWrapper}
          data-image-preview
          $isImageClickable={false}
          html={currentQuestion.comprehension[currentLanguage.code]}
        />
      </Comprehension>

      <Question maxHeight={maxHeight} />
    </Wrapper>
  );
};

export default QuestionWithComprehension;
